export enum EoViewComponentTypeEnum {
  TEXT=1,
  DATE=2,
  LABEL=3,
  CURRENCY=4
}
